import orm from 'models'
import { createSelector as ormSelector } from 'redux-orm'
import getEntities from 'selectors/entities'

// All loaded todos, open ones first (completed are struck-through until the next reload,
// since the index endpoint only returns open todos). Insertion order is preserved within
// each group, and V8's sort is stable.
const getTodos = ormSelector(orm, getEntities, (session) =>
  session.todo.all().toModelArray()
    .filter(todo => !todo.deleted)
    .map((todo) => {
      const dossier = todo.dossierId && session.dossier.withId(todo.dossierId)
      const patient = dossier && session.contact.withId(dossier.patientId)
      const clientName = patient ? `${patient.firstName} ${patient.lastName}` : null
      return { ...todo.ref, clientName }
    })
    .sort((a, b) => (a.completedAt ? 1 : 0) - (b.completedAt ? 1 : 0))
)

export default getTodos
